import React, { useState, useEffect } from 'react';
import { districtService, countryService, stateService } from '../../services/api';
import './AdminPage.css';

function AdminDistrict() {
  const [districts, setDistricts] = useState([]);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingDistrict, setEditingDistrict] = useState(null);
  const [formData, setFormData] = useState({
    Name: '',
    CountryId: '',
    StateId: ''
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadData();
    loadDropdowns();
  }, []);

  useEffect(() => {
    if (formData.CountryId) {
      loadStates();
    }
  }, [formData.CountryId]);

  const loadData = async () => {
    try {
      setLoading(true);
      const data = await districtService.getDistricts();
      setDistricts(data);
    } catch (error) {
      alert('Error loading districts: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  const loadDropdowns = async () => {
    try {
      const data = await countryService.getCountries();
      setCountries(data);
    } catch (error) {
      console.error('Error loading dropdowns:', error);
    }
  };

  const loadStates = async () => {
    try {
      const data = await stateService.getStates();
      setStates(data.filter(s => s.CountryId === parseInt(formData.CountryId)));
    } catch (error) {
      console.error('Error loading states:', error);
    }
  };

  const handleAdd = () => {
    setEditingDistrict(null);
    setFormData({ Name: '', CountryId: '', StateId: '' });
    setIsModalOpen(true);
  };

  const handleEdit = (district) => {
    setEditingDistrict(district);
    setFormData({
      Id: district.Id,
      Name: district.Name || '',
      CountryId: district.CountryId || '',
      StateId: district.StateId || ''
    });
    setIsModalOpen(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this district?')) {
      try {
        await districtService.deleteDistrict(id);
        loadData();
      } catch (error) {
        alert('Error deleting district: ' + error.message);
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      await districtService.saveDistrict(formData);
      setIsModalOpen(false);
      loadData();
    } catch (error) {
      alert('Error saving district: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-page">
      <div className="page-header page-headeradmin">
        <h1>District Management</h1>
        <button className="btn-primary" onClick={handleAdd}>Add District</button>
      </div>

      {loading && !districts.length ? (
        <div className="loading">Loading...</div>
      ) : (
        <div className="table-container">
          <table className="data-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Country</th>
                <th>State</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {districts.map((district) => (
                <tr key={district.Id}>
                  <td>{district.Name}</td>
                  <td>{district.Country?.Name}</td>
                  <td>{district.State?.Name}</td>
                  <td>
                    <button className="btn-edit" onClick={() => handleEdit(district)}>Edit</button>
                    <button className="btn-delete" onClick={() => handleDelete(district.Id)}>Delete</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {isModalOpen && (
        <div className="modal-overlay" onClick={() => setIsModalOpen(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>{editingDistrict ? 'Edit District' : 'Add District'}</h2>
              <button className="modal-close" onClick={() => setIsModalOpen(false)}>×</button>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="form-grid">
                <div className="form-group">
                  <label>Name *</label>
                  <input
                    type="text"
                    value={formData.Name}
                    onChange={(e) => setFormData({ ...formData, Name: e.target.value })}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Country *</label>
                  <select
                    value={formData.CountryId}
                    onChange={(e) => setFormData({ ...formData, CountryId: e.target.value, StateId: '' })}
                    required
                  >
                    <option value="">Select Country</option>
                    {countries.map((country) => (
                      <option key={country.Id} value={country.Id}>{country.Name}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group">
                  <label>State *</label>
                  <select
                    value={formData.StateId}
                    onChange={(e) => setFormData({ ...formData, StateId: e.target.value })}
                    disabled={!formData.CountryId}
                    required
                  >
                    <option value="">Select State</option>
                    {states.map((state) => (
                      <option key={state.Id} value={state.Id}>{state.Name}</option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="modal-actions">
                <button type="button" className="btn-secondary" onClick={() => setIsModalOpen(false)}>Cancel</button>
                <button type="submit" className="btn-primary" disabled={loading}>
                  {loading ? 'Saving...' : 'Save'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default AdminDistrict;

